import React from "react";
import { Table } from "reactstrap";
import { array } from "prop-types";
import "./searchClientProfileEntriesTable.css";

import ProfileDetailsEntriesTableRow from "./row";

const SearchClientProfileEntriesTable = ({ clientProfileEntries }) => {
  const rows = clientProfileEntries.map((entry) => (
    <ProfileDetailsEntriesTableRow key={entry.clientNumber} entry={entry} />
  ));

  return (
    <Table className="client-profile-table mt-4">
      <thead className="thead-light">
        <tr>
          <th>Category Type</th>
          <th>Full name</th>
          <th>EGN / Company number</th>
          <th className="center">Actions</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </Table>
  );
};

SearchClientProfileEntriesTable.propTypes = {
  clientProfileEntries: array.isRequired,
};

export default SearchClientProfileEntriesTable;



// WEBPACK FOOTER //
// ./src/features/client-profile/components/searching/search-form/table/SearchClientProfileEntriesTable.jsx